/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import FormValidationService from 'walden-fast/services/form-validation';

interface FormErrorMessagesArgs {
  errors?: string[];
  fieldName?: string;
}

export default class FormErrorMessagesComponent extends Component<FormErrorMessagesArgs> {
  @service('form-validation')
  declare formValidationService: FormValidationService;

  get displayErrors(): string[] {
    // If errors are provided directly, use them
    if (this.args.errors) {
      return this.args.errors;
    }

    // Otherwise, get errors from service's internal state
    if (this.args.fieldName) {
      return this.formValidationService.getFieldErrors(this.args.fieldName);
    }

    return [];
  }
}
